import * as Sentry from '@sentry/react';
import { sanitizeSentryBreadcrumb, sanitizeSentryEvent } from './observabilitySanitizer';

const isProduction = import.meta.env.MODE === 'production';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
  sendDefaultPii: false,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      maskAllInputs: true,
      blockAllMedia: true,
      networkCaptureBodies: false,
      networkRequestHeaders: [],
      networkResponseHeaders: [],
    }),
  ],
  tracesSampleRate: isProduction ? 0.15 : 1.0,
  replaysSessionSampleRate: isProduction ? 0 : 0.1,
  // Mantém somente um buffer local. Ao aparecer um aviso vermelho, o app envia
  // o trecho anterior e uma janela curta posterior — nunca a sessão inteira.
  replaysOnErrorSampleRate: 1.0,
  beforeBreadcrumb: sanitizeSentryBreadcrumb,
  beforeSend: sanitizeSentryEvent,
  beforeSendTransaction: sanitizeSentryEvent,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
});
